module.exports = __webpack_public_path__ + "img/about-photo-6.04193c8.jpg";